// ⚠️如果项目需要兼容 ie11，则需要引入下面两行 polyfill
// These must be the first lines in src/index.tsx
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { defaultLocaleDetectOrder, i18n, i18nInit, LocaleContextProvider } from '@fuxi/eevee-hooks';
import { EEVEE_ICON_YAOTAI_CDN_URL, SPECIFIC_LANG } from 'common-package/src/constants';
import zhJson from '@commonPackage/locales/zh.json';
import enJson from '@commonPackage/locales/en.json';
import { EeveeIconContextProvider } from '@commonPackage/components';
import '@/styles/index.less';
import '@/styles/overwrite.less';
import '@/styles/global.less';
import 'common-package/src/styles/variables.css';
import '@/styles/variables.css';
import 'uno.css';
import { Provider } from 'react-redux';
import { getCommonStore } from '@commonPackage/store';
import { getTrackEnv } from '@commonPackage/utils';
import { Env } from '@yaotai/yaotai-tracker';
import { LANG_LOCAL_STORAGE_KEY, LANG_QUERY_STRING, SUPPORT_LANG_LIST } from '@yaotai/common-utils';
import App from './App';

window.initNECaptchaWithFallback = initNECaptchaWithFallback;

const langJsonList = [zhJson, enJson];

i18nInit({
  langList: SUPPORT_LANG_LIST,
  langJsonList,
  querystring: LANG_QUERY_STRING,
  localStorageKey: LANG_LOCAL_STORAGE_KEY,
  fallbackLng: 'zh',
  moreInitOptions: {
    lng: SPECIFIC_LANG,
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);

// 按照检测顺序配置得到的最佳匹配语言
const detectBestMatchedLang = i18n.services.languageDetector.detect(defaultLocaleDetectOrder)[0];

root.render(
  <Provider store={getCommonStore({ isProd: getTrackEnv(import.meta.env.VITE_APP_MODE ?? '') === Env.Prod })}>
    <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
      <EeveeIconContextProvider cdnLink={EEVEE_ICON_YAOTAI_CDN_URL} defaultSize={16}>
        <LocaleContextProvider
          detectLang={detectBestMatchedLang}
          specifiedLang={SPECIFIC_LANG}
          langConfig={{
            zh: ['zh-CN'],
            en: ['en', 'en-US'],
          }}
          langList={SUPPORT_LANG_LIST}
          languageChangeCallback={i18n.changeLanguage.bind(i18n)}>
          <App />
        </LocaleContextProvider>
      </EeveeIconContextProvider>
    </StyleProvider>
  </Provider>,
);
